import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import OrderSummaryModal from "./OrderSummaryModal";
import { formatCurrency } from "../utils";
import { FaShoppingCart } from "react-icons/fa";

export default function FloatingCart({ inline = false }) {
  const { state } = useCart();
  const [open, setOpen] = useState(false);

  const items = state.items;

  const subtotal = items.reduce(
    (s, it) =>
      s +
      (it.price + (it.extras || []).reduce((x, e) => x + e.price, 0)) * it.qty,
    0,
  );

  return (
    <>
      <div className={inline ? "cart-inline" : "floating-cart"}>
        <button className="cart-toggle" onClick={() => setOpen(true)}>
          <FaShoppingCart />
          Pedido
          <span className="cart-total">{formatCurrency(subtotal)}</span>
        </button>
      </div>

      <OrderSummaryModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
